import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import './index.less';
import { CloseOutlined } from '@m-ui/icons';
import anime from 'animejs';
import { renderLoginComponent } from '@ad/uc';
import RiskPlugin from '@ks/weblogger/lib/plugins/riskMgt';
import DMPLogger from 'utils/logger';
import { addRadarEvent } from 'utils/businesslog';
import { RouterPath } from '@/constants/constants';

export interface IProps {
    visible: boolean;
    onCancel: () => void;
}

export function LoginModal(props: IProps) {
    const $logicRef = useRef();

    const webLog = new DMPLogger();

    useEffect(() => {
        anime({
            targets: ['.login-modal .login-wrap>div'],
            opacity: props.visible ? [0, 1] : [1, 0],
            translateY: props.visible ? [-40, 0] : [0, -40],
            easing: 'spring(1, 80, 10, 0)',
            duration: 200,
        });
    }, [props.visible]);

    useEffect(() => {
        renderLoginComponent({
            target: $logicRef.current,
            policyUrl: '/user-agreement',
            supportRegister: false,
            redirectUrl: `${window.location.protocol}//${window.location.host}${RouterPath.FRONT_PAGE}?type=1`,
            followUrl: `${window.location.protocol}//${window.location.host}`,
            webLog: webLog.weblog,
            RiskPlugin: RiskPlugin as any,
            onSuccess: (data) => {
                // 重定向
                window.location.replace(
                    `${window.location.protocol}//${window.location.host}${RouterPath.FRONT_PAGE}?type=1`,
                );
                addRadarEvent({
                    name: 'SLI_DMP_LOGIN',
                    result_type: 'success',
                    message: '登录成功',
                    extra_info: JSON.stringify(data),
                });
            },
            onError: (data) => {
                addRadarEvent({
                    name: 'SLI_DMP_LOGIN',
                    result_type: 'fail',
                    message: data?.errorMsg,
                    extra_info: JSON.stringify(data),
                });
                data.showError(data?.errorMsg);
            },
        });
    }, []);

    return (
        <div
            className={cx('login-modal', {
                hidden: !props.visible,
            })}
            onClick={props.onCancel}
        >
            <div className="login-wrap" onClick={(e) => e.stopPropagation()}>
                <div>
                    <span className="close-icon" onClick={props.onCancel}>
                        <CloseOutlined />
                    </span>
                    <div className="login-comp">
                        <div ref={$logicRef}></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default React.memo(LoginModal);
